var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.542A3.542 3.542 0 0 1 14.542 14h15.583a3.542 3.542 0 0 1 3.542 3.542v9.916A3.542 3.542 0 0 1 30.125 31H14.542A3.542 3.542 0 0 1 11 27.458v-9.916Zm3.542-1.18a1.18 1.18 0 0 0-1.18 1.18v9.916c0 .652.528 1.18 1.18 1.18h15.583a1.18 1.18 0 0 0 1.18-1.18v-1.18H18.084a2.361 2.361 0 0 1-2.36-2.361h15.583v-6.375a1.18 1.18 0 0 0-1.181-1.18H14.542Z",
    fill: "#6171FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.722 20.139a1.417 1.417 0 1 1 2.834 0 1.417 1.417 0 0 1-2.834 0Z",
    fill: "#6171FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.c1253231.svg";
export { ForwardRef as ReactComponent };